import React from 'react';
import {PendingInventoryActivityVO} from "../../../types/model/valueObject/pendinginventoryactivity/PendingInventoryActivityVO";
import {SupplierPendingInventoryActivityCardListItem} from "./SupplierPendingInventoryActivityCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";
import { ReportDialogSetterProps } from "../../../interfaces";

type SupplierPendingInventoryActivityCardListProps = {
  items?: PendingInventoryActivityVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
  onEdit?: (item: PendingInventoryActivityVO) => void;
  onOpenDialog: (dialog: ReportDialogSetterProps<PendingInventoryActivityVO>) => void;
}

const SupplierPendingInventoryActivityCardList = ({
  items,
  expandByIndex,
  onToggleExpand,
  onEdit,
  onOpenDialog
}: SupplierPendingInventoryActivityCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <SupplierPendingInventoryActivityCardListItem
          key={item.id}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
          onEdit={onEdit}
          onOpenDialog={onOpenDialog}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const SupplierPendingInventoryActivityCardListWithLoader = withLoader(SupplierPendingInventoryActivityCardList, skeletonLoader);

export {
  SupplierPendingInventoryActivityCardList,
  SupplierPendingInventoryActivityCardListWithLoader
};
